import { useQuery } from '@tanstack/react-query'
import { useCallback, useMemo } from 'react'
import { toast } from 'react-toastify'

import { PulverizationFromDemandResponse } from '@/services/create-pulverization'
import { getSummaryPulverization } from '@/services/get-summary-pulverization'
import { queryClient } from '@/services/query-client'

export const GET_PULVERIZATION_RESUME_QUERY = 'GET_PULVERIZATION_RESUME'

export function useGetPulverizationFromDiagnosis(
  culture: string,
  diagnosisId: string,
  enabled = false,
) {
  const queryKey = useMemo(
    () => [GET_PULVERIZATION_RESUME_QUERY, culture, diagnosisId],
    [culture, diagnosisId],
  )

  const query = useQuery(
    queryKey,
    ({ signal }) => getSummaryPulverization(culture, diagnosisId, { signal }),
    {
      enabled,
      onError(e: any) {
        toast.error(
          'Ocorreu um erro ao buscar o resumo de pulverização: ' + e.message,
        )
      },
    },
  )

  const setQueryData = useCallback(
    (data: PulverizationFromDemandResponse) => {
      queryClient.setQueryData<PulverizationFromDemandResponse>(queryKey, data)
    },
    [queryKey],
  )

  return { ...query, setQueryData }
}
